import {
  YOUTUBE_UPLOADS_LOADED,
  YOUTUBE_UPLOADS_LOAD_FAILURE
} from '../constants';
import { dealStatuses, userStatuses } from '../../constants';
import axios from 'axios';
import { getChannelCountryDemographics } from '../../services/youtubeAnalyticsService';

export const signInWithYoutube = (firstName, lastName) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    await window.gapi.auth2.init({
      client_id: process.env.REACT_APP_YOUTUBE_CLIENT_ID,
      scope: 'https://www.googleapis.com/auth/youtube.readonly'
    });

    //this allows us to get the refresh token even if it isn't the first time the user has logged in
    // remove this block for sign UP, leave for sign IN

    const authInstance = window.gapi.auth2.getAuthInstance();

    console.log('window.gapi client init complete');

    const authToken = await authInstance.signIn({
      prompt: 'select_account'
    });

    console.log('sign in complete');

    window.gapi.client.setApiKey(process.env.REACT_APP_API_KEY);

    return window.gapi.client
      .load('https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest')
      .then(function() {
        // console.log('window.gapi client loaded for API');
        return window.gapi.client.youtube.channels
          .list({
            part: 'snippet,contentDetails,statistics',
            mine: true
          })
          .then(
            async response => {
              if (response.result.items && response.result.items.length) {
                const youtubeUser = response.result.items[0];
                if (youtubeUser.statistics.subscriberCount >= 0) {
                  axios
                    .get(`http://localhost:9000/signup`)
                    .then(() => {
                      console.log('success');
                    })
                    .catch(err => {
                      console.log('error');
                    });

                  return await handleChannelResponse(
                    youtubeUser,
                    firstName,
                    lastName,
                    firebase,
                    firestore
                  );
                } else {
                  // doesnt have 100 subscribers
                  return { error: 'subscriberCount' };
                }
              } else {
                return { error: 'usernameNotFound' };
              }
            },
            function(err) {
              console.error('Execute error', err);
            }
          );
      });
  };
};

const handleChannelResponse = async (
  youtubeUser,
  firstName,
  lastName,
  firebase,
  firestore,
  refreshToken
) => {
  const youtubeUsername = youtubeUser.snippet.customUrl;
  const youtubeChannelId = youtubeUser.id;
  const youtubePlaylistId = youtubeUser.contentDetails.relatedPlaylists.uploads;
  const youtubeUserPhoto = youtubeUser.snippet.thumbnails.medium.url;

  if (youtubeChannelId) {
    const authInstance = window.gapi.auth2.getAuthInstance();
    const googleUser = authInstance.currentUser.get();
    const isSignedIn = authInstance.isSignedIn.get();
    if (isSignedIn) {
      // get the credentials from the google auth response
      const authRespose = googleUser.getAuthResponse();
      const idToken = authRespose.id_token;

      const googleCreds = firebase.auth.GoogleAuthProvider.credential(idToken);
      const youtube = {
        googleCreds: JSON.stringify({ ...authRespose, refreshToken })
      };

      console.log(`google token; ${JSON.stringify(authRespose)}`);

      const creds = await firebase
        .auth()
        .signInAndRetrieveDataWithCredential(googleCreds);

      if (creds.additionalUserInfo.isNewUser) {
        const user = creds.user;
        try {
          console.log(`youtube object; ${JSON.stringify(youtube)}`);
          await firestore
            .collection('users')
            .doc(user.uid)
            .set({
              email: user.email,
              youtubeUsername: youtubeUsername ? youtubeUsername : '',
              youtubeChannelId: youtubeChannelId ? youtubeChannelId : '',
              youtubePlaylistId: youtubePlaylistId ? youtubePlaylistId : '',
              profilePictureUrl: youtubeUserPhoto,
              firstName: firstName,
              lastName: lastName,
              displayName: `${
                youtubeUsername ? youtubeUsername : firstName + ' ' + lastName
              }`,
              isCompany: false,
              googleId: googleUser ? googleUser.getId() : '',
              status: userStatuses.ACTIVE,
              createdAt: firestore.FieldValue.serverTimestamp(),
              signUpComplete: false,
              youtube
            });
        } catch (error) {
          console.log(error);
        }
        //set initial youtube data
        const idToken = await firebase.auth().currentUser.getIdToken(false);

        return axios
          .post(
            `${process.env.REACT_APP_FIREBASE_URL}/saveInitialYoutubeData`,
            {
              idToken
            }
          )
          .then(() => {
            return { success: true };
          })
          .catch(err => {
            return { error: true };
          });
      }
    }
  }
};

export const loadRelevantUploads = companyId => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    // LOGIC:
    // if company has no deals, load videos from top influencers (can query deals table and take influencerID from completed deals)
    // if company has deals, get videos from active deals first
    // if no active or not yet 5 videos get from completed or pending

    //MVP LOGIC:
    //display content from most recent completed deals
    firestore
      .collection('deals')
      .where('status', '==', dealStatuses.COMPLETE)
      .orderBy('createdAt', 'desc')
      .limit(5)
      .get()
      .then(dealSnapshots => {
        if (dealSnapshots.docs.length) {
          const requests = dealSnapshots.docs.map(dealDoc => {
            return new Promise(resolve => {
              firestore
                .collection('deals')
                .doc(dealDoc.id)
                .collection('content')
                .get()
                .then(contentSnapshot => {
                  if (!contentSnapshot.empty) {
                    const content = contentSnapshot.docs[0].data();
                    resolve({
                      addedAt: content.timestamp,
                      videoId: content.videoId
                    });
                  } else {
                    resolve({});
                  }
                });
            });
          });

          Promise.all(requests).then(content => {
            dispatch({
              type: YOUTUBE_UPLOADS_LOADED,
              payload: content
            });
          });
        } else {
          dispatch({
            type: YOUTUBE_UPLOADS_LOADED,
            payload: []
          });
        }
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/youtubeActions.js